exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-demo[data-v-d8324ea4]{display:inline-block}", ""]);

// exports
